module.exports = __webpack_public_path__ + "img/login_img.5ed74ee3.png";